/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_OrgsInputs */

const th_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โรงเรียนของคุณ`)
};

const en_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your schools`)
};

const ja_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの学校`)
};

const zh_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的学校`)
};

const es_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus centros`)
};

const pt_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas escolas`)
};

const id_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekolah Anda`)
};

const fr_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos établissements`)
};

const tl_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga paaralan mo`)
};

const vi_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trường của bạn`)
};

const ko_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 학교`)
};

const de_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Schulen`)
};

const ru_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши школы`)
};

const tr_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okullarınız`)
};

const it_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue scuole`)
};

const pl_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje szkoły`)
};

const uk_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші школи`)
};

const hi_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके स्कूल`)
};

const ar_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدارسك`)
};

const ms_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekolah anda`)
};

const bn_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার স্কুল`)
};

const zh_tw2_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的學校`)
};

const zh_hk2_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的學校`)
};

const ur_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کے اسکول`)
};

const fa_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرسه‌های شما`)
};

const sw_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shule zako`)
};

const nl_your_orgs = /** @type {(inputs: Your_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw scholen`)
};

/**
* | output |
* | --- |
* | "Your schools" |
*
* @param {Your_OrgsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_orgs = /** @type {((inputs?: Your_OrgsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_OrgsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_orgs(inputs)
	if (locale === "ja") return ja_your_orgs(inputs)
	if (locale === "zh") return zh_your_orgs(inputs)
	if (locale === "es") return es_your_orgs(inputs)
	if (locale === "pt") return pt_your_orgs(inputs)
	if (locale === "id") return id_your_orgs(inputs)
	if (locale === "fr") return fr_your_orgs(inputs)
	if (locale === "tl") return tl_your_orgs(inputs)
	if (locale === "vi") return vi_your_orgs(inputs)
	if (locale === "ko") return ko_your_orgs(inputs)
	if (locale === "de") return de_your_orgs(inputs)
	if (locale === "ru") return ru_your_orgs(inputs)
	if (locale === "tr") return tr_your_orgs(inputs)
	if (locale === "it") return it_your_orgs(inputs)
	if (locale === "pl") return pl_your_orgs(inputs)
	if (locale === "uk") return uk_your_orgs(inputs)
	if (locale === "hi") return hi_your_orgs(inputs)
	if (locale === "ar") return ar_your_orgs(inputs)
	if (locale === "ms") return ms_your_orgs(inputs)
	if (locale === "bn") return bn_your_orgs(inputs)
	if (locale === "zh-TW") return zh_tw2_your_orgs(inputs)
	if (locale === "zh-HK") return zh_hk2_your_orgs(inputs)
	if (locale === "ur") return ur_your_orgs(inputs)
	if (locale === "fa") return fa_your_orgs(inputs)
	if (locale === "sw") return sw_your_orgs(inputs)
	if (locale === "nl") return nl_your_orgs(inputs)
	return en_your_orgs(inputs)
});